let Page   = require('../mixins/base-page');
let Search = require('../mixins/base-search');

module.exports = {
 	mixins: [Page, Search],

 	computed: {
		searchResultsUnsorted() {
			let results = [];

			for(letter in this.searchResults) {
				results = results.concat(this.searchResults[letter]);
			}

			return results;
		}
 	},

	created() {
		this.setFilters({
			type: ["equipment", "ingredient", "term"]
		})
	},
	
	methods: {
		search() {
			this.searching = true;
			
			// @note
			// There are 5000+ terms in the database, so instead of returning 
			// everything for the initial, unfiltered request, we'll use a 
			// different endpoint, as long as no filters are set.
			if(this.searchTerm === '' && !this.filterValues['type'].length) {
				this.sendRequest(this.defaultEndpoint, 'get', this.updateResults);
			} else {
				this.sendRequest(this.searchUrl, 'get', this.updateResults);
			}
		},
	}
};
